import Dice from './Dice';

function Board({ name, color, gameHistory, dataCheck }) {
	const num = gameHistory[gameHistory.length - 1] || 1;
	const sum = gameHistory.reduce((a, b) => a + b, 0);

	return (
		<div className="Board App-board" data-check={dataCheck}>
			<h2 className="Board-heading">{name}</h2>
			<Dice color={color} num={num} />
			<h2 className="Board-heading">기록</h2>
			<p>{gameHistory.join(', ')}</p>
			<h2 className="BOard-heading">총점</h2>
			<p>{sum}</p>
		</div>
	);
}

export default Board;
